"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var MorningStar_meta_1 = require("../MorningStar.meta");
var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");
var starIcon = function () { return (react_1.default.createElement("svg", { viewBox: "0 0 1024 1024" },
    react_1.default.createElement("path", { d: "M540.312 0l-111.753 350.685-436.534-3.507 352.719 256-160.644 420.822 356.212-259.507 324.781 227.945-129.214-389.26 352.719-256-436.534 3.507-111.753-350.685z" }))); };
exports.default = InjectedStyledComponent_1.InjectedStyledComponent(starIcon, MorningStar_meta_1.MORNING_STAR_CATEGORY_KEY, MorningStar_meta_1.MORNING_STAR_COMPONENT_KEY, ['morningStarIcon']);
